import resume from "../assets/pdf/resume.pdf";
import myImage from "../assets/jpeg/ME.jpeg";

export const headerData = {
  name: "Gemechu Tiko",
  title: "Full Stack Software Developer",
  desciption:
    "Experienced Full Stack Developer skilled in Javascript, node, Typescript, React, AWS, NodeJS, MongoDB, MySQL, and more. Proven track record in delivering end-to-end projects, from concept to troubleshooting. adept in all software development lifecycle phases.",
  image: myImage,
  resumePdf: resume,
};
